import { learningContents } from '@/mocks/masterCourseData';
import { useTranslation } from 'react-i18next';

const LEARNING_COUNT = 6;
const learningIndices = Array.from({ length: LEARNING_COUNT }, (_, i) => i);

const imageUrls: Record<string, string> = {
  'master-household': '/images/generated/master-household-2026.jpg',
  'master-crisis': '/images/generated/master-crisis-2026.jpg',
  'master-protocol': '/images/generated/master-protocol-2026.jpg',
  'master-vip': '/images/generated/master-vip-2026.jpg',
  'master-situations': '/images/generated/master-situations-2026.jpg',
  'master-leadership': '/images/generated/master-leadership-2026.jpg',
};

function renderParagraphs(text: string, className: string) {
  return text.split(/\n{2,}/).map((paragraph, index) => (
    <p key={index} className={className}>
      {paragraph}
    </p>
  ));
}

export default function LearningContent() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-16">
          {renderParagraphs(
            t('coursesMaster.learning.label'),
            'text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label',
          )}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesMaster.learning.titleAlt')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {renderParagraphs(
            t('coursesMaster.learning.leadAlt'),
            'text-[16px] text-foreground-600 tracking-[0.04em] max-w-xl mx-auto leading-relaxed',
          )}
        </div>
        <div className="space-y-16 md:space-y-24">
          {learningIndices.map((index) => {
            const item = learningContents[index];
            const isEven = index % 2 === 0;
            const title = t(`coursesMaster.learning.${index}.title`);
            return (
              <div key={index} className={`flex flex-col ${isEven ? 'md:flex-row' : 'md:flex-row-reverse'} gap-8 md:gap-12 items-center`}>
                <div className="w-full md:w-1/2">
                  <div className="overflow-hidden">
                    <img
                      src={imageUrls[item?.imageSeq ?? '']}
                      alt={t('coursesMaster.learning.imgAlt').replace('{title}', title)}
                      title={t('coursesMaster.learning.imgTitle').replace('{title}', title)}
                      className="w-full object-cover object-top transition-transform duration-700 hover:scale-105"
                    />
                  </div>
                  <div className="mt-3 h-[1px] bg-gradient-to-r from-transparent via-accent-500/20 to-transparent"></div>
                </div>
                <div className="w-full md:w-1/2">
                  <div className="flex items-center gap-4 mb-4">
                    <span className="w-10 h-10 flex items-center justify-center">
                      <i className={`${item?.icon} text-accent-600 text-xl`}></i>
                    </span>
                    <div>
                      {renderParagraphs(
                        t(`coursesMaster.learning.${index}.titleEn`).toUpperCase(),
                        'text-[12px] text-accent-500/70 tracking-[0.15em] font-label mb-1',
                      )}
                      <h3 className="font-heading text-lg text-foreground-900 tracking-[0.06em]">
                        {title}
                      </h3>
                    </div>
                  </div>
                  {renderParagraphs(
                    t(`coursesMaster.learning.${index}.description`),
                    'text-[16px] text-foreground-700 leading-relaxed tracking-[0.03em]',
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
